<template>
    <div class="container">
        <div class="login">
            <div class="login-body">
                <form @submit.prevent="login">
                    <div class="login-header">
                        <div class="block-logo">
                            <img class="logo" src="../../assets/logo.svg" :alt="$t('main_label')">
                        </div>
                        <h1>{{$t('auth.pwd_rec_label')}}</h1>
                    </div>
                    <div class="login-inputs">
                        <input class="login-input login-error" v-if="!!error" v-model="error" type="text" readonly>
                        <input class="login-input" type="email" :placeholder="$t('auth.email_label')">
                    </div>
                    <div class="login-buttons">
                        <router-link class="login-link" :to="'/sign/in'">{{$t('auth.back_to_main_label')}}</router-link>
<!--                        &nbsp;-->
<!--                        {{$t('auth.or_label')}}-->
<!--                        &nbsp;<router-link class="login-link" :to="'/sign/up'">{{$t('auth.create_acc_label').toLowerCase()}}</router-link>-->
                    </div>
                    <div class="login-buttons">
                        <button class="login-button" type="submit">{{$t('auth.remind_label')}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Recover'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/Recover.vue